export function filterRecentByStatus(ticketsByEmp, daysAgo = 7) {
  const now = Date.now();
  const threshold = now - daysAgo * 24 * 60 * 60 * 1000;

  return Object.entries(ticketsByEmp).reduce((acc, [emp, details]) => {
    const recentList = details.ticketList.filter((ticket) => {
      if (!ticket.updated) return false;
      const updatedTime = new Date(ticket.updated).getTime();
      return (
        ["In Review", "Done", "Ready for review"].includes(ticket.status) &&
        updatedTime >= threshold
      );
    });

    if (recentList.length > 0) {
      acc[emp] = {
        ...details,
        ticketList: recentList
      };
    }

    return acc;
  }, {});
}
